import * as React from 'react';
import SvgImage from '../SvgImage';
import { Link as LinkType } from '../../../typings';
import './styles.scss';

const Link = ({
  title,
  url,
  isExternal = false,
  isButton = false,
  icon,
  iconAfter,
  className = '',
  ariaLabel,
  buttonType = 'text-link',
  buttonColour = 'white',
}: LinkType) => {
  const isDisabled = () => (
    url === null || url === ''
  );

  const root = 'link';
  const classes = [root, className];

  if (icon || iconAfter) {
    classes.push(`${root}--has-icon`);
  }

  if (isButton) {
    classes.push('button');
  }

  if (isDisabled()) {
    classes.push(`${root}--disabled`);
  }

  if (buttonType) {
    classes.push(buttonType);
  }

  if (buttonColour) {
    classes.push(`${root}--${buttonColour}`);
  }

  return (
    <a
      className={classes.join(' ')}
      target={isExternal ? '_blank' : '_self'}
      href={url}
      rel="noreferrer"
      aria-label={ariaLabel}
    >
      {icon && (
        <div className="link__icon">
          <SvgImage {...icon} />
        </div>
      )}
      <span>{title}</span>
      {iconAfter && (
        <div className="link__icon link__icon--after">
          <SvgImage {...iconAfter} />
        </div>
      )}
    </a>
  );
};

export default Link;
